module.exports = __webpack_public_path__ + "img/ZeroPickingS1Page.809e6962.png";